import { createApp } from "vue";
import App from "./App.vue";

import PrimeVue from "primevue/config";
/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router/clean";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

import Chips from "primevue/chips";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import "@/core/plugins/prismjs";

import "primeicons/primeicons.css";
import "primevue/resources/themes/lara-light-indigo/theme.css";
import "primevue/resources/primevue.min.css";
const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(PrimeVue);

ApiService.init(app);

initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);
app.component("ChipsCom", Chips);
app.mount("#app");
